import React, { useState, useEffect } from 'react';
import { Table, Button, Drawer, KeyValuePairs, Modal, Badge, Link, SplitPanel, HelpPanel, Container, CopyToClipboard, Flashbar, FlashbarProps } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import Pagination from '@cloudscape-design/components/pagination';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import CollectionPreferences from '@cloudscape-design/components/collection-preferences';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiBell, mdiBike, mdiCarBack, mdiEye, mdiEyeOff, mdiHelpCircleOutline, mdiLock, mdiLockOpen, mdiMotorbike, mdiRefresh, mdiTruck, mdiCamera, mdiAlphaRBox, mdiAlphaKBox, mdiAlphaGBox, mdiAlphaHBox, mdiNumeric5Box, mdiNumeric7Box, mdiBoomGateArrowUp, mdiBellRing } from '@mdi/js';
import Icon from '@mdi/react';
import { formatPhone } from '../../../commons/functions';

const pageSize = 20;

interface Access {
    label: string;
    value: string;
    description?: string;
    idAcceso: number;
    acceso: string;
    canHandleVisits: number;
    relay: number;
}
export const NotificationsListPage = () => {
    const storeAdmin = useStoreAdmin();
    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
    const [pendingJobCreation, setPendingJobCreation] = useState(false);
    const { idPropiedad, setIdPropiedad } = useGlobalState();
    const { propiedad, setPropiedad } = useGlobalState();
    const { idControl, setIdControl } = useGlobalState();
    const { JWT, setJWT } = useGlobalState();
    const [loadingButtonId, setLoadingButtonId] = useState<string | null>(null);
    const [selectedRow, setSelectedRow] = useState<any>(null);  // Stores selected row data


    const [helpOpen, setHelpOpen] = useState(false);
    const [sideOpen, setSideOpen] = useState(false);

    const [btnAuths, setBtnAuths] = useState(true);
    const [selectedNotifications, setSelectedNotifications] = useState<string[]>([]);

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const [selectedItems, setSelectedItems] = useState<UserNotification[]>([]);
    const [accesses, setAccesses] = useState<Access[]>([]);
    const [access, setAccess] = useState<Access>();
    const { setLoading } = useGlobalState();
    const [btnActionDisable, setBtnActionDisable] = useState<boolean>(true);
    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filteringText, setFilteringText] = useState('');
    const [selectedRowUnit, setSelectedRowUnit] = useState('');
    const [notifications, setNotifications] = useState<UserNotification[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalAccess, setIsModalAccess] = useState(false);

    const handleViewImageClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    type UserNotification = {
        idNotificacion: string;
        fecha: string;
        SNPropiedad: string;
        type: string;
        unidad: string;
        idControl: string;
        autorizado: number;
        nombre: string;
        empresa: string;
        RUT: string;
        PPU: string;
        transport: string;
        pax: number;
        displayName: string;
        movil: string;
        photoUrl: string;
        fechaLectura: string;
        reqAuth: number;
        hora: string;
        horaLectura: string;
        horaAutorizacion: string;
        fechaAutorizacion: string;
        obsEmisor: string;
        obsReceptor: string;
        isErrorDestinatario: string;
        fechaTAG: string;
    };


    const filteredNotifications = notifications.filter(notifications => {
        const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
        return searchWords.every(word =>
            notifications.displayName.toLowerCase().includes(word) ||
            notifications.movil.toLowerCase().includes(word) ||
            notifications.unidad.toLowerCase().includes(word)
        );
    });

    const paginatedNotifications = filteredNotifications.slice(
        (currentPageIndex - 1) * pageSize,
        currentPageIndex * pageSize
    );

    const handleSelectionChange = ({ detail }: any) => {
        setSelectedItems(detail.selectedItems);
        setBtnActionDisable(detail.selectedItems.length === 0);
        if (detail.selectedItems.length > 1) setSideOpen(false);
    };

    useEffect(() => {
        setBtnAuths(selectedNotifications.length == 0)
    }, [selectedNotifications]); // The effect runs every time selectedAccesses changes

    // Handle row click to fetch additional data and open the HelpPanel
    const handleRowClick = async (rowData: UserNotification) => {
        setSelectedRow(rowData);  // Store selected row data
        setLoading(true);
        try {
            // Simulate a fetch request to get additional data for the row
            // Example of a fetched data structure
            const userDetails = {
                idNotificacion: rowData.idNotificacion,
                displayName: rowData.displayName,
                unidad: rowData.unidad,
                movil: rowData.movil,
                empresa: rowData.empresa,
                nombre: rowData.nombre,
                PPU: rowData.PPU,
                RUT: rowData.RUT,
                transport: rowData.transport,
                pax: rowData.pax,
                hora: rowData.hora,
                horaLectura: rowData.horaLectura,
                fechaAutorizacion: rowData.fechaAutorizacion,
                photoUrl: rowData.photoUrl,
                obsEmisor: rowData.obsEmisor,
                obsReceptor: rowData.obsReceptor,
                isErrorDestinatario: rowData.isErrorDestinatario,
                autorizado: rowData.autorizado,
                fechaTAG: rowData.fechaTAG,
                reqAuth: rowData.reqAuth
            };
            setSelectedRow(userDetails);
            setSelectedRowUnit(userDetails.unidad)
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
            setSideOpen(true);
            setHelpOpen(false);
        }
    };
    useEffect(() => {
    }, [selectedRow]);
    const handleRefresh = async () => {
        setSideOpen(false);
        setHelpOpen(false);
        setPendingJobCreation(true)
        try {
            setLoading(true)
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/notifications/list',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            storeAdmin(data)
            setNotifications(data.notifications);

            const mapped: Access[] = data.accesses
                .filter((item: { canHandleVisits: number }) => item.canHandleVisits === 1)
                .map((item: { acceso: string; idAcceso: string; relay:number }) => ({
                    label: item.acceso,
                    value: item.idAcceso.toString(),
                    acceso: item.acceso,
                    idAcceso: item.idAcceso,
                    relay: item.relay,
                }));

            setAccesses(mapped);

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
            setPendingJobCreation(false)
        }
    };

    const handleBtnAccess = async (item: Access) => {
        setLoadingButtonId(item.idAcceso.toString());
        try {
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/notifications/open',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    idNotificacion: selectedRow.idNotificacion,
                    idAcceso: item.idAcceso,
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data && data.result) {
                setMessages([
                    {
                        type: data.result.code === 1 ? 'success' : 'error',
                        header: "Resultado",
                        content: `${data.result.status}`,
                    },
                ])
                setIsModalAccess(false)
                setTimeout(() => {
                    setMessages([]);
                }, 5000);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoadingButtonId(null);
        }

    };

    useEffect(() => {

        handleRefresh();
    }, []);

    const handleHelp = async () => {
        setHelpOpen(!helpOpen)
    }
    return (
        <>
            <Modal
                visible={isModalAccess}
                onDismiss={() => setIsModalAccess(false)}
                header="Confirmación"
                size="small"
            >
                {access && (
                    <SpaceBetween direction='vertical' size='xs'>
                        <Box textAlign='center'>{access.relay === 0 ? <Icon path={mdiBellRing} size={3} /> : <Icon path={mdiBoomGateArrowUp} size={3} />}</Box>
                        <Box textAlign='center'>{access.acceso}</Box>

                        <Box textAlign='center'>
                            <Button variant="primary" onClick={() => handleBtnAccess(access)} fullWidth>{access.relay === 0 ? "Notificar" : "Aperturar"}</Button>
                        </Box>
                    </SpaceBetween>
                )}
            </Modal>

            <CustomAppLayout
                toolsOpen={helpOpen}
                onToolsChange={({ detail }) => setHelpOpen(detail.open)}
                splitPanelOpen={sideOpen}
                onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}
                tools={
                    helpOpen && (
                        <HelpPanel
                            header={
                                <Header variant="h2">Ayuda</Header>
                            }
                        ><p>Las notificaciones activas, son todas aquellas las cuales han sido emitidas en las últimas 24 horas, ya sea desde la consola de administración asi como desde la App de LlaveMovil.</p>

                            <p> Para generar una nueva notificación haga click en <Link href='#notifications/add' variant="primary">Agregar notificación</Link>. Como mínimo deberá seleccionar una unidad y un residente dentro de la unidad. Otra información sera solicitada y eventualmente obligatoria dependiendo de la configuración de su propiedad y el tipo de notificación seleccionada</p>

                        </HelpPanel>
                    )
                }
                splitPanel={
                    selectedRow && (
                        <SplitPanel hidePreferencesButton header={`Notificación #${selectedRow.idNotificacion}`} closeBehavior='hide'>
                            <SpaceBetween direction="vertical" size="xs">
                                <Container
                                    header={
                                        <Header variant="h3">
                                            Destinatario{" "}
                                            {selectedRow.reqAuth === 1 ? (
                                                selectedRow.autorizado === 1 ? (
                                                    <Badge color="green">Autorizado</Badge>
                                                ) : selectedRow.autorizado === 0 ? (
                                                    <Badge color="severity-medium">No Autorizado</Badge>
                                                ) : (
                                                    <Badge color="severity-medium">Pendiente</Badge>
                                                )
                                            ) : (
                                                <Badge color="severity-neutral">Notificado</Badge> // or render as plain text if preferred
                                            )}
                                        </Header>
                                    }
                                >

                                    <KeyValuePairs
                                        columns={1}
                                        items={[
                                            {
                                                label: "Usuario",
                                                value: (
                                                    `${selectedRow.displayName} (${formatPhone(selectedRow.movil)})`
                                                )
                                            }
                                        ]}
                                    />
                                    <KeyValuePairs
                                        columns={2}
                                        items={[{
                                            label: "Unidad",
                                            value: selectedRow.unidad
                                        },
                                        {
                                            label: "Hora",
                                            value: `${selectedRow.hora} ${selectedRow.horaLectura !== '' ? `(Leído ${selectedRow.horaLectura})` : ''}`
                                        },
                                        ]} />

                                </Container>

                                <Flashbar items={messages} />
                                {accesses.map((item: Access) => (
                                    <Button
                                        variant="primary"
                                        fullWidth
                                        disabled={!(selectedRow.reqAuth === 0 || selectedRow.autorizado === 1)}
                                        key={item.idAcceso.toString()}
                                        loading={loadingButtonId === item.idAcceso.toString()}
                                        onClick={() => {
                                            setAccess(item)
                                            setIsModalAccess(true)
                                        }}
                                    >
                                        {item.acceso}
                                    </Button>
                                ))}
                                <Container header={<Header variant="h3">Información</Header>}>
                                    <KeyValuePairs
                                        columns={2}
                                        items={[{
                                            label: selectedRow.unidad,
                                            value: selectedRow.displayName
                                        },
                                        selectedRow.obsEmisor !== '' ? {
                                            label: "Observaciones Emisor",
                                            value: selectedRow.obsEmisor
                                        } : null,
                                        selectedRow.obsReceptor !== '' ? {
                                            label: "Observaciones Receptor",
                                            value: selectedRow.obsReceptor
                                        } : null,
                                        selectedRow.nombre !== '' ? {
                                            label: "Nombre",
                                            value: selectedRow.nombre
                                        } : null,
                                        selectedRow.empresa !== '' ? {
                                            label: "Empresa",
                                            value: selectedRow.empresa
                                        } : null,
                                        selectedRow.RUT !== '' ? {
                                            label: "RUT",
                                            value: selectedRow.RUT
                                        } : null,
                                        selectedRow.PPU !== '' ? {
                                            label: "Matrícula",
                                            //value: selectedRow.PPU
                                            value:
                                                (<><Icon path={mdiAlphaRBox} size={1} /><Icon path={mdiAlphaKBox} size={1} />
                                                    <Icon path={mdiAlphaGBox} size={1} /><Icon path={mdiAlphaHBox} size={1} />
                                                    <Icon path={mdiNumeric7Box} size={1} /><Icon path={mdiNumeric5Box} size={1} />
                                                </>)
                                        } : null,
                                        selectedRow.transport !== '' ? {
                                            label: "Transporte",
                                            value: `${selectedRow.transport}${selectedRow.pax} ${selectedRow.pax && selectedRow.pax > 0 ? ` (${selectedRow.pax} pasajer${selectedRow.pax > 1 ? 'os' : 'o'})` : ''}`
                                        } : null,
                                        ].filter(Boolean) as { label: string; value: any }[]}
                                    />
                                </Container>
                                <div style={{ height: '20px' }}></div>
                                {selectedRow.photoUrl !== '' ? <Button onClick={handleViewImageClick}>Ver Imagen</Button> : null}
                                <Modal
                                    visible={isModalOpen}
                                    onDismiss={handleCloseModal}
                                    header="Imagen"
                                    size="large"
                                >
                                    <img src={selectedRow.photoUrl} alt="Imagen" style={{ maxWidth: '100%', maxHeight: '80vh', display: 'block', margin: '0 auto' }} />
                                </Modal>

                            </SpaceBetween>
                        </SplitPanel>
                    )}

                contentType="form"
                breadcrumbs={
                    <BreadcrumbGroup
                        items={[
                            { text: 'Inicio', href: '#home' },
                            { text: 'Notificaciones', href: '#notifications' },
                            { text: 'Listado', href: '#notifications' },
                            /*{ text: 'Listar notificaciones', href: '#create-transcription-job' },*/
                        ]}
                        expandAriaLabel="Show path"
                        ariaLabel="Breadcrumbs"
                    />
                }
                content={
                    <>
                        <SpaceBetween direction="vertical" size="xs">
                            <Header

                                actions={
                                    <SpaceBetween direction="horizontal" size="xs">

                                        <Button variant="normal" href='#notifications/add'>
                                            Agregar notificacion
                                        </Button>
                                        <Button variant="primary" onClick={handleRefresh} loading={pendingJobCreation} iconName="refresh"></Button>
                                    </SpaceBetween>
                                }
                                info={<Link onClick={handleHelp}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                            /*info={<Link variant="info">Info</Link>}*/
                            >
                                Notificaciones activas{' '}
                                {notifications?.length > 0 && (
                                    <Badge color="grey">{notifications.length.toString()}</Badge>
                                )}
                            </Header>
                            <Table
                                stripedRows
                                renderAriaLive={({ firstIndex, lastIndex, totalItemsCount }) =>
                                    `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`
                                }
                                onSelectionChange={handleSelectionChange}
                                selectedItems={selectedItems}
                                onRowClick={({ detail }) => handleRowClick(detail.item)}
                                ariaLabels={{
                                    selectionGroupLabel: "Items selection",
                                    allItemsSelectionLabel: () => "select all",
                                    itemSelectionLabel: ({ selectedItems }, item) => item.idControl,
                                }}
                                columnDefinitions={[
                                    {
                                        id: "hora",
                                        header: "Hora",
                                        cell: (item) => {


                                            let reqAuth = null;
                                            if (item.reqAuth === 1 && item.fechaAutorizacion === "") {
                                                reqAuth = <Icon path={mdiLock} size={1} color={"red"} />
                                            } else if (item.reqAuth === 1 && item.fechaAutorizacion !== "") {
                                                reqAuth = <Icon path={mdiLockOpen} size={1} color={"green"} />;
                                            } else {
                                                reqAuth = <Icon path={mdiBell} size={1} color={"#gray"} />;
                                            }
                                            const fechaTAG = item.fechaTAG;
                                            if (fechaTAG === "TAG.TODAY") {
                                                return (<>{reqAuth} {item.hora} {<Badge color="green">Hoy</Badge>}</>);
                                            } else if (fechaTAG === "TAG.YESTERDAY") {
                                                return (<>{reqAuth} {item.hora} {<Badge color="blue">Ayer</Badge>}</>);
                                            } else {
                                                return `${reqAuth} ${item.hora}`
                                            }
                                        }
                                    },
                                    {
                                        id: "type",
                                        header: "Tipo",
                                        cell: (item) => {
                                            const value = item.type;
                                            let icon = null;
                                            if (item.transport) {
                                                if (item.transport === "TRUCK") {
                                                    icon = <Icon path={mdiTruck} size={1} />
                                                }
                                                else if (item.transport === "MOTO") {
                                                    icon = <Icon path={mdiMotorbike} size={1} />
                                                }
                                                else if (item.transport === "BIKE") {
                                                    icon = <Icon path={mdiBike} size={1} />
                                                }
                                                else if (item.transport === "CAR") {
                                                    icon = <Icon path={mdiCarBack} size={1} />
                                                }
                                                else if (item.transport === "TRUCK") {
                                                    icon = <Icon path={mdiTruck} size={1} />
                                                }
                                            }
                                            let label;
                                            if (value === "VISIT") {
                                                label = "Visita";
                                            } else if (value === "MAIL") {
                                                label = "Encomienda";
                                            } else if (value === "DELIVERY") {
                                                label = "Delivery";
                                            } else {
                                                label = "Desconocido";
                                            }
                                            let wasRead = null;
                                            if (item.horaLectura !== "") {
                                                wasRead = <Icon path={mdiEye} size={1} color={"#444"} />;
                                            } else {
                                                wasRead = <Icon path={mdiEyeOff} size={1} color={"#ccc"} />;
                                            }
                                            return (
                                                <span className="flex items-center">
                                                    {label}
                                                    {icon}
                                                    {wasRead}
                                                </span>
                                            )
                                        },
                                        //sortingField: "type",
                                        isRowHeader: true,
                                    },
                                    {
                                        id: "displayName",
                                        header: "Residente",
                                        cell: (item) => item.displayName,
                                        //sortingField: "displayName",
                                        isRowHeader: true,
                                    },
                                    {
                                        id: "unidad",
                                        header: "Unidad",
                                        cell: (item) => item.unidad,
                                        //sortingField: "unidad",
                                    },
                                    {
                                        id: "photoUrl",
                                        header: "",
                                        cell: (item) => {
                                            const value = item.photoUrl;

                                            if (value !== "") {
                                                return (<Link onClick={(event) => { event.stopPropagation(); handleViewImageClick(); }}><Icon path={mdiCamera} size={1} /></Link>)
                                            }
                                        },
                                        //sortingField: "type", 
                                        isRowHeader: true,
                                    },
                                ]}
                                items={paginatedNotifications}
                                //selectionType="multi"
                                trackBy="idNotificacion"
                                empty={
                                    <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
                                        <SpaceBetween size="m">
                                            <b>No tiene notificaciones activas</b>
                                            <Button href='#notifications/add'>Crear notificación</Button>
                                        </SpaceBetween>
                                    </Box>
                                }
                                filter={
                                    <TextFilter
                                        filteringText={filteringText}
                                        onChange={({ detail }) => {
                                            setFilteringText(detail.filteringText);
                                            setCurrentPageIndex(1);
                                        }}
                                    />
                                }
                                pagination={
                                    filteredNotifications.length > pageSize && (
                                        <Pagination
                                            currentPageIndex={currentPageIndex}
                                            pagesCount={Math.ceil(filteredNotifications.length / pageSize)}
                                            onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                        />
                                    )
                                }

                            />
                        </SpaceBetween>

                    </>
                }
            />
        </>
    );
};
